import React, { useEffect, createElement } from 'react';
import { LivoniaHeroInfo } from './livonia/LivoniaHeroInfo';
import { LivoniaHeroForm } from './livonia/LivoniaHeroForm';
import { LivoniaDistance } from './livonia/LivoniaDistance';
import { LivoniaWhy } from './livonia/LivoniaWhy';
import { LivoniaPrograms } from './livonia/LivoniaPrograms';
import { LivoniaScheduleLocation } from './livonia/LivoniaScheduleLocation';
import { LivoniaReviews } from './livonia/LivoniaReviews';
import { LivoniaFAQHeader } from './livonia/LivoniaFAQHeader';
import { LivoniaFAQQuestions } from './livonia/LivoniaFAQQuestions';
import { LivoniaLinks } from './livonia/LivoniaLinks';
import { LivoniaFinalCTA } from './livonia/LivoniaFinalCTA';
export function Livonia() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Livonia, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for martial arts near Livonia? Storm Taekwondo offers beginner-friendly classes for kids and adults. Try one week free.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for martial arts near Livonia? Storm Taekwondo offers beginner-friendly classes for kids and adults. Try one week free.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2363">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2364">
        <div className="absolute inset-0 opacity-20" data-id="element-2365">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2366" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2367" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2368">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2369">
            <LivoniaHeroInfo data-id="element-2370" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2371">
              <LivoniaHeroForm data-id="element-2372" />
            </div>
          </div>
        </div>
      </section>

      <LivoniaDistance data-id="element-2373" />
      <LivoniaWhy data-id="element-2374" />
      <LivoniaPrograms data-id="element-2375" />
      <LivoniaScheduleLocation data-id="element-2376" />
      <LivoniaReviews data-id="element-2377" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-2378">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2379">
          <LivoniaFAQHeader data-id="element-2380" />
          <LivoniaFAQQuestions data-id="element-2381" />
        </div>
      </section>
      <LivoniaLinks data-id="element-2382" />
      <LivoniaFinalCTA data-id="element-2383" />
    </div>;
}